<script>
	import WhoopsError from "./WhoopsError.svelte";
	import {
		entities,
		entitiesSplit,
		entitiesArray,
		entitiesPages,
		debug,
		popup,
		api_feed,
		api_writeForm,
		inviewIdx,
		engageButtons,
	} from "./stores.js";
	import {
		writeForm,
		formatQueryString,
		getExpParams,
		getRedirectRoutes,
	} from "./utils.js";
	import Navbar from "./components/Navbar.svelte";
	import Right from "./Right.svelte";
	import Left from "./Left.svelte";
	import { getContext } from "svelte";
	import Instructions from "./modals/Instructions.svelte";
	import Consent from "./modals/Consent.svelte";
	import { textConsent, textInstructions } from "./placeholderText.js";
	import FeedScroll from "./FeedScroll.svelte";
	import FeedSwipe from "./FeedSwipe.svelte";
	import Engage from "./Engage.svelte";

	console.log("checkpoint");
	writeForm($api_writeForm, {
		checkpoint: "feed-landed",
	});

	let stimPerScroll = 10;
	let mainLeft = false; // left column
	let mainRight = false; // right column
	let consentModal = true;
	let instructionsModal = true;
	let queryParams;
	let experiment_id;
	let feedType = "scroll";

	// post queryParams
	const queryStringObj = formatQueryString();
	if (Object.keys(queryStringObj).length > 0) {
		console.log("Post queryParams:", queryStringObj);
		writeForm($api_writeForm, queryStringObj);
	}

	const checkParams = () => {
		queryParams = JSON.parse(localStorage.getItem("queryParams"));
		experiment_id = localStorage.getItem("experiment_id");
		if (experiment_id === "solarflare") {
			consentModal = false;
			instructionsModal = false;
		}

		// if consent/instructions value is empty, don't show modal
		let expParams = getExpParams();
		if (expParams.consent === "") {
			consentModal = false;
		}
		if (expParams.instruct === "") {
			instructionsModal = false;
		}
	};

	const getFeedType = () => {
		let expParams = getExpParams();
		if (expParams["feed"]) {
			feedType = expParams["feed"];
		}
	};

	// specify what buttons to show (default = all four buttons)
	// options: likes, shares, read_later, accuracy_score
	let engageButtonOptions = [
		"shares",
		"likes",
		"read_later",
		"accuracy_score",
		"upvote",
		"downvote",
	];
	const getEngageButtons = () => {
		let expParams = getExpParams();
		console.log(expParams);
		engageButtonOptions = [];
		if (
			expParams["feed-button-share"] !== "no" &&
			expParams["feed-button-share"] !== ""
		) {
			engageButtonOptions.push("shares");
		}
		if (
			expParams["feed-button-like"] !== "no" &&
			expParams["feed-button-like"] !== ""
		) {
			engageButtonOptions.push("likes");
		}
		if (
			expParams["feed-button-bookmark"] !== "no" &&
			expParams["feed-button-bookmark"] !== ""
		) {
			engageButtonOptions.push("read_later");
		}
		if (
			expParams["feed-button-accuracy"] !== "no" &&
			expParams["feed-button-accuracy"] !== ""
		) {
			engageButtonOptions.push("accuracy_score");
		}
		if (
			expParams["feed-button-upvote"] !== "no" &&
			expParams["feed-button-upvote"] !== ""
		) {
			engageButtonOptions.push("upvote");
		}
		if (
			expParams["feed-button-downvote"] !== "no" &&
			expParams["feed-button-downvote"] !== ""
		) {
			engageButtonOptions.push("downvote");
		}
		if (engageButtonOptions.length == 0) {
			engageButtonOptions = [
				"shares",
				"likes",
				"read_later",
				"accuracy_score",
				"upvote",
				"downvote",
			];
		}
		engageButtons.set(engageButtonOptions);
	};

	// show popup/info modal on load
	// https://github.com/flekschas/svelte-simple-modal
	const { open, close } = getContext("simple-modal");
	const showConsent = (onClosed) => {
		if (!$popup) {
			return false;
		}
		open(
			Consent,
			{ onClose: close, text: textConsent },
			{
				closeButton: true,
				closeOnOuterClick: false,
				// styleBg: { "background-color": "grey" },
			},
			{
				onClosed: () => {
					if (onClosed !== undefined) {
						onClosed();
					}
				},
			},
		);
	};

	const showInstructions = (onClosed) => {
		if (!$popup) {
			return false;
		}
		open(
			Instructions,
			{ onClose: close, text: textInstructions },
			{
				closeButton: false,
				closeOnOuterClick: false,
				// styleBg: { "background-color": "grey" },
				transitionBgProps: { duration: 377 },
				transitionWindowProps: {
					duration: 0,
				},
			},
			{
				onClosed: () => {
					if (onClosed !== undefined) {
						onClosed();
					}
				},
			},
		);
	};

	const showModalsOnLoad = () => {
		checkParams();
		if (consentModal && instructionsModal) {
			showConsent(showInstructions);
		} else if (consentModal) {
			showConsent();
		} else if (instructionsModal) {
			showInstructions();
		} else {
			console.log("not showing any modals");
		}
	};

	// check if entities already exist in localStorage
	const checkEntitiesLocalstorage = () => {
		if (localStorage.getItem("entities")) {
			console.log("Entities found in localStorage");
			return true;
		} else {
			console.log("Entities not found in localStorage");
			return false;
		}
	};

	// parse stimuli loaded from load_feed_stimuli endpoint
	const parseStimuli = (stimuli, stimPerScroll = 25) => {
		// 250513_215754 get entity_url from each stimulus to send to qualtrics
		let stimuliUrl = stimuli.map((stim) => {
			return stim.entity_url;
		});
		// send message to parent frame to send stimuliUrl to qualtrics
		window.parent.postMessage(
			{
				stimuliUrl: JSON.stringify(stimuliUrl),
			},
			"*",
		);
		let list = [];
		let templist = [];
		for (let i = 0; i < stimuli.length; i++) {
			let s = stimuli[i];
			s.idx = i;
			if (templist.length >= stimPerScroll) {
				list.push(templist);
				templist = [];
			}
			templist.push(s);
		}
		if (templist.length > 0) {
			list.push(templist);
		}
		console.log("Split into", list.length, "arrays for infinite loading");
		console.log(list);
		entitiesSplit.set(list);
		entitiesArray.set(list[0]); // 1st page for infinite loading
		entitiesPages.set(list.length);
		return list;
	};

	async function loadFeedStimuli() {
		console.log("Retrieving stimuli - calling load_feed_stimuli...");
		console.log("localStorage", localStorage);
		const resp = await fetch($api_feed, {
			method: "POST",
			mode: "cors",
			cache: "default",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({
				user_id: localStorage.getItem("user_id"),
				experiment_id: localStorage.getItem("experiment_id"),
			}),
		});

		console.log("Waiting for response...");
		const response = await resp.json();
		console.log("response", response);
		if (response.success === "true") {
			if ($debug) {
				const nStim = 15;
				stimPerScroll = 5;
				response.order_data = response.data.order_data.slice(0, nStim);
			}
			console.log(
				"Retrieved " + response.data.order_data.length + " stimuli",
			);
			stimPerScroll = Math.min(
				stimPerScroll,
				response.data.order_data.length - 1,
			);
			console.log("stimPerScroll", stimPerScroll);
			console.log("Save to store: entities");
			entities.set(response.data.order_data);
			console.log("Save localstorage: entities");
			localStorage.setItem(
				"entities",
				JSON.stringify(response.data.order_data),
			);
			if (response.data.experiment_parameters) {
				const params = response.data.experiment_parameters;
				localStorage.setItem("experiment_parameters", params);
				console.log("experiment_parameters:", JSON.parse(params));
				showModalsOnLoad();
			}
			if (response.data.condition) {
				const condition_num = response.data.condition;
				localStorage.setItem("condition", condition_num);
				console.log("condition:", JSON.parse(condition_num));
				writeForm($api_writeForm, { condition: condition_num });
			}
			getFeedType();
			getEngageButtons();
			// get redirection routes (saves them to localStorage as redirectionRoutes)
			getRedirectRoutes();
			return parseStimuli(response.data.order_data, stimPerScroll);
		} else {
			getFeedType();
			getEngageButtons();
			console.log("Failed to retrieve stimuli");
		}
	}

	// prepare stimuli for feed; determine whether to call loadFeedStimuli
	let stimuli;
	if (checkEntitiesLocalstorage()) {
		console.log("NOT calling load_feed_stimuli");
		let entitiesLocalStorage = JSON.parse(localStorage.getItem("entities"));
		entities.set(entitiesLocalStorage);
		if ($debug) {
			const nStim = 15;
			stimPerScroll = 5;
			entitiesLocalStorage = entitiesLocalStorage.slice(0, nStim);
		}
		stimuli = parseStimuli(entitiesLocalStorage, stimPerScroll);
		getFeedType();
		getEngageButtons();
		getRedirectRoutes();
	} else {
		console.log("calling load_feed_stimuli");
		stimuli = loadFeedStimuli();
	}

	// send message to server every 5 entities
	$: if ($inviewIdx > 4 && $inviewIdx % 5 == 0) {
		console.log("checkpoint");
		writeForm($api_writeForm, {
			checkpoint: "feed-entity-idx-" + $inviewIdx,
		});
	}
</script>

<Navbar />
<!-- <svelte:window on:load={showModalsOnLoad} /> -->

<svelte:window
	on:beforeunload={() => {
		writeForm($api_writeForm, {
			checkpoint: "leave_feed-entity-idx-" + $inviewIdx,
		});
	}}
/>

<div id="app">
	<main class="main-grid">
		<section
			class="main-left"
			style="border-width: {mainLeft ? '1px' : '0px'}"
		>
			<Left />
		</section>

		<section class="media-card-container center">
			{#await stimuli then array}
				{#if feedType == "scroll"}
					<FeedScroll></FeedScroll>
				{:else if feedType == "swipe"}
					<FeedSwipe></FeedSwipe>
				{/if}
			{:catch error}
				<div style="text-align: center">
					<WhoopsError {error} />
				</div>
			{/await}
		</section>

		<section
			class="main-right"
			style="border-width: {mainRight ? '1px' : '0px'}"
		>
			<Right />
		</section>
	</main>
</div>

<style>
	/* for debugging */
	/* * {
		border: 1px red solid !important;
	} */

	/* compound global css selector */

	.main-grid {
		display: grid;
		grid-template-columns: 1fr 500px 1fr;
		grid-template-areas: "left center right";
	}
	.main-left {
		grid-area: left;
		height: 100%;
		width: auto;
	}
	.center {
		grid-area: center;
	}
	.main-right {
		grid-area: right;
		height: 100%;
		width: auto;
	}

	/* @media (max-width: 950px) {
		section:is(.main-left) {
			display: none;
		}
		section:is(.main-right) {
			display: none;
		}
		.main-grid {
			grid-template-columns: 1fr;
		}
	} */

	@media (max-width: 700px) {
		section:is(.main-left) {
			display: none;
		}
		section:is(.main-right) {
			display: none;
		}
		.main-grid {
			grid-template-columns: 1fr;
		}
	}

	@media (max-height: 650px) {
		.main-grid {
			display: grid;
			grid-template-columns: 1fr 350px 1fr;
			grid-template-areas: "left center right";
		}
	}
	.main-left,
	.main-right {
		font-size: 11px;
		margin: 21px 0 0 0;
		padding: 5px 13px 0 13px;
		border: 1px solid rgba(232, 232, 232, 0.4);
	}
	.media-card-container {
		margin: 21px 0 34px 0;
	}
</style>
